import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';

/**
 * Componente simplificado para ver los detalles de un usuario específico
 */
const UserView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirigir directamente a UserManagement con el ID del usuario
    navigate(`/admin/users/${id}`);
  }, [id, navigate]);

  return (
    <AdminLayout title="Ver Usuario" subtitle="Redirigiendo...">
      <div className="loading">Redirigiendo a la página de gestión de usuarios...</div>
    </AdminLayout>
  );
};

export default UserView;
